import { Box, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import { BankAccountSelector } from '../../../../profile/components/bank-account-selector';
import { PriceField } from '../../../../../components/formik/price-field/price-field';

const Styled = {
    PartnerBox: styled(Box)(({ theme }) => {
        return {
            display: 'flex',
            alignItems: 'center',
            marginTop: theme.spacing(2),

            '.MuiFormHelperText-root': {
                display: 'none',
            },
        };
    }),
    BankAccountSelector: styled(BankAccountSelector)(({ theme }) => {
        return {
            '.MuiFormControl-root': {
                marginBottom: 0,

                '.MuiInputBase-root': {
                    padding: 0,
                    '&:not(.Mui-error)': {
                        '&:hover': {
                            fieldset: {
                                borderColor: theme.palette.border.main,
                            },
                        },
                    },
                },
            },

            '& .MuiInputBase-formControl': {
                borderRadius: '8px 0px 0px 8px',
            },

            '.MuiInputBase-root.MuiOutlinedInput-root.Mui-error fieldset': {
                borderRight: '0 !important',
            },

            fieldset: {
                borderRight: '0 !important',
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
            },
        };
    }),
    TextField: styled(PriceField)(({ theme }) => {
        return {
            width: '30%',
            [theme.breakpoints.down('md')]: {
                width: '50%',
            },
            '.MuiInputBase-root.MuiOutlinedInput-root:not(.Mui-error)': {
                '&:hover': {
                    fieldset: {
                        borderColor: theme.palette.border.main,
                    },
                },
            },

            '& .MuiInputBase-formControl': {
                borderRadius: '0px 8px 8px 0px',
            },

            '.MuiInputBase-root.MuiOutlinedInput-root.Mui-error fieldset': {
                borderLeft: '0 !important',
            },

            fieldset: {
                borderLeft: '0 !important',
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
            },
        };
    }),
    AppendButton: styled(IconButton)(({ theme }) => {
        return {
            color: theme.palette.text.secondary,
            backgroundColor: theme.palette.primary.main,
            borderRadius: '100px',
            width: '30px',
            height: '30px',
            marginTop: theme.spacing(2),
            '&:hover': {
                backgroundColor: theme.palette.primary.main,
            },
        };
    }),
};

export { Styled };
